import React from 'react';
import DashboardLayout from '../../layouts/DashboardLayout';
import { Box, Typography, Card, CardContent, Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import LGModalCrud from '../../organisms/LGCrud/LGModalCrud';
import EstimateItemForm from '../../organisms/Quoting/EstimateItemForm.tsx';
import { getEstimateItems, deleteEstimateItem } from '../../api/quotations/estimateItems.ts';
import { percentageFormatter } from '../../services/valueFormatters.js';

interface QuoteData {
  id: string;
  code: string;
  name: string;
  client: {
    id: string;
    name: string;
    code: string;
  };
  currency: {
    id: string;
    symbol: string;
  };
  createdAt: string;
}

const QuotingWizardScreen: React.FC = () => {
  const location = useLocation();
  const quoteData = location.state as QuoteData;

  return (
    <DashboardLayout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Detalles de la Cotización
        </Typography>
        
        {quoteData ? (
          <>
            <Card sx={{ mt: 3 }}>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle1" color="text.secondary">
                      Código
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {quoteData.code}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle1" color="text.secondary">
                      Nombre
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {quoteData.name}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle1" color="text.secondary">
                      Cliente
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                       {quoteData.client?.name} {quoteData.client?.code ? `(${quoteData.client?.code})` : 'SIN CLIENTE'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" color="text.secondary">
                      Moneda
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {quoteData.currency?.symbol}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" color="text.secondary">
                      Fecha de Creación
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {new Date(quoteData.createdAt).toLocaleDateString()}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            <Box sx={{ mt: 4 }}>
              <Typography variant="h5" gutterBottom>
                Cpomponentes de la Cotización
              </Typography>
              <LGModalCrud
                props={{  
                  actions: ["create", "update", "delete"],
                  persistPagination: true,
                  data: { estimateId: quoteData.id },
                  fetchFunction: getEstimateItems,
                  deleteFunction: deleteEstimateItem,
                  columns: [
                    {
                      field: "name",
                      headerName: "Nombre",
                      flex: 0.3,
                    },
                    {
                      field: "quantity",
                      headerName: "Cantidad",
                      flex: 0.2,
                    },
                    {
                      field: "productCategory",
                      headerName: "Sustrato",
                      flex: 0.3,
                      valueGetter: (row) => row.name || '',
                    },
                    {
                      field: "attributes",
                      headerName: "Dimensiones",
                      flex: 0.3,
                      valueGetter: (row) => {
                        const { width, height, thickness } = row || {};
                        return width && height ? `${width} x ${height} cm | ${thickness || ''}` : '';
                      },
                    },
                    {
                      field: "processes",
                      headerName: "Procesos",
                      flex: 0.3,
                      renderCell: (params) => (
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          {params.row.processes?.map((process, index) => (
                            <Typography key={index} variant="body2">
                              {process.process.name}
                            </Typography>
                          )) || ''}
                        </Box>
                      ),
                    },
                    {
                      field: "product",
                      headerName: "Código de materia prima óptima",
                      flex: 0.3,
                      valueGetter: (row) => row?.code || '',
                    },

                    {
                      field: "coveragePercentage",
                      headerName: "Porcentaje de llenado",
                      flex: 0.3,
                      valueGetter: (value, row) => {
                        return row.attributes?.coveragePercentage || 0;
                      },
                      ...percentageFormatter,
                    },

                    {
                      field: "totalItemsFit",
                      headerName: "Total de piezas",
                      flex: 0.3,
                      valueGetter: (value, row) => {
                        return row.attributes?.totalItemsFit || 0;
                      },
                    },

                    // {
                    //   field: "productCost",
                    //   headerName: "Costo",
                    //   flex: 0.2,
                    //   valueGetter: (params) => `${quoteData.currency.symbol} ${params.row.productCost}`,
                    // },
                  ],
                  addModalData: {
                    header: "Agregar Componente",
                    body: <EstimateItemForm estimateId={quoteData.id} onSubmit={() => {}} />,
                  },
                  editModalData: {
                    header: "Editar Componente",
                    body: <EstimateItemForm estimateId={quoteData.id} onSubmit={() => {}} />,
                  },
                }}
              />
            </Box>
          </>
        ) : (
          <Typography variant="body1" color="error">
            No se encontraron datos de la cotización
          </Typography>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default QuotingWizardScreen; 